import { Filter, Redirection, RelatedTag } from '@empathy/search-types';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { DynamicConfig, EmpathyXConfig, ScrollDirection } from '../../../models';
import { GETTERS_KEYS, SUBMODULES_PATHS } from '../../../store';
import { VueCssClasses } from '../../../utils';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['inputQuery', 'open', 'scrollDirection', 'scrollOffset', 'hasTabbed']),
    ...mapState(SUBMODULES_PATHS.config, ['device', 'dynamic']),
    ...mapState(SUBMODULES_PATHS.empathize, { isLoadingEmpathize: 'loading' }),
    ...mapState(SUBMODULES_PATHS.search, ['directs', 'loading', 'numFound', 'query', 'spellcheck']),
    ...mapState(SUBMODULES_PATHS.querySignals, ['relatedTags']),
    ...mapGetters({
      showEmpathizeOpen: GETTERS_KEYS.empathize.showOpen,
      selectedFilters: GETTERS_KEYS.search.selectedFilters,
      config: GETTERS_KEYS.config.config
    })
  }
})
export class CoreClassesMixin extends Vue {
  config: EmpathyXConfig;
  device: string;
  directs: Redirection[];
  dynamic: DynamicConfig;
  hasTabbed: boolean;
  inputQuery: string;
  isLoadingEmpathize: boolean;
  loading: boolean;
  numFound: number;
  open: boolean;
  query: string;
  spellcheck: string;
  scrollDirection: ScrollDirection;
  scrollOffset: boolean;
  showEmpathizeOpen: boolean;
  selectedFilters: Filter[];
  relatedTags: RelatedTag[];

  get coreClasses(): VueCssClasses {
    return [
      `ebx-empathy-x--${ this.device }`,
      `ebx-empathy-x--${ this.dynamic.instance }`,
      `ebx-empathy-x--lang-${ this.dynamic.lang }`,
      `ebx-empathy-x--search-lang-${ this.dynamic.searchLang }`,
      `ebx-empathy-x--scroll-${ this.scrollDirection }`,
      {
        'ebx-empathy-x--opened': this.open,
        'ebx-empathy-x--no-query': !this.query,
        'ebx-empathy-x--no-input-query': !this.inputQuery,
        'ebx-empathy-x--outline-disabled': !this.hasTabbed,
        'ebx-empathy-x--direct-link-detected': this.directs.length > 0 && this.config.redirection.autoRedirect,
        'ebx-empathy-x--empathize-open': this.showEmpathizeOpen,
        'ebx-empathy-x--search-loading': this.loading,
        'ebx-empathy-x--empathize-loading': this.isLoadingEmpathize,
        'ebx-empathy-x--no-results': this.numFound === 0 && !!this.query && !this.loading,
        'ebx-empathy-x--has-results': this.numFound > 0,
        'ebx-empathy-x--scroll-offset': this.scrollOffset,
        'ebx-empathy-x--filtered': this.selectedFilters.length > 0,
        'ebx-empathy-x--has-related-tags': this.relatedTags.length > 0,
        'ebx-empathy-x--spellcheck': !!this.spellcheck
      }
    ];
  }
}
